/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectPlan from 'modules/me/select-kiosk-plan';
import CurrentKioskPlanCard from './index/current-plan-card';
import PlanDetailsCard from './index/plan-details-card';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import Notice from 'components/notice';

// new
import AnnotatedSection from 'components/annotated-section';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import BillingDetailsCard from './index/billing-details-card';

/**
 * Style dependencies
 */
import './styles.scss';

const Kiosk = (props) => {
    return (
        <Box>
            <DocumentHead title='Billing - Manage Customer Self Checkout Plan - Tower Systems' />
            <Topbar title='Customer Self Checkout Plan' subTitle='Manage your Customer Self Checkout plan' selected='kiosk'>
            </Topbar>
            <Main padding='xxlarge'>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Subscription Details'
                            description='Customer Self Checkout plan details.'
                        />
                        <AnnotatedSection.Content>
                            <CurrentKioskPlanCard />
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
    }),
    {},
)(Kiosk);
